<template>
    <div ref="wrapper" :class="wrapperClass">
        <div ref="contentArea">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: "BaseScrollCluster",

    props: {
        ifScrollHorizon: {
            type: Boolean,
            default: false,
        },

        contentHeight: {
            type: Number,
            default: -1,
        },

        showScroll: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            //
            wrapperClass: '',

            //
            originScrollTop: 0,
            originScrollLeft: 0,

            //
            clusterize: null,
        }
    },

    mounted()
    {
        //
        if(this.ifScrollHorizon)
        {
            //
            this.wrapperClass = 'wrapperHorizon';

            //
            if(this.showScroll)
            {
                this.$refs.wrapper.style['overflow-x'] = 'scroll';
            }
        }
        else
        {
            //
            this.wrapperClass = 'wrapperVertical';

            //
            if(this.showScroll)
            {
                this.$refs.wrapper.style['overflow-y'] = 'scroll';
            }
        }

        this.$refs.wrapper.addEventListener("scroll", this.scrollListener);

        //
        this.checkContentHeight('mounted');
    },

    updated()
    {
        //
        this.checkContentHeight('updated');
    },

    methods: {
        initCluster()
        {
            //
            this.clusterize = new Clusterize({
                scrollElem: this.$refs.wrapper,
                contentElem: this.$refs.contentArea,
                rows_in_block: 10,
                callbacks: {
                    clusterWillChange: function () {
                        console.log("********************* clusterWillChange")
                    },
                    clusterChanged: function () {
                        console.log("##################### clusterChanged")
                    },
                    scrollingProgress: function (progress) {
                        
                    }
                }
            });
        },

        async checkContentHeight(checkType)
        {
            //
            if(process.env.NODE_ENV == 'development')
            {
                console.log(`BaseScrollCluster checkContentHeight ${checkType}`)
            }

            //
            while(!this.$refs.wrapper.firstChild.firstChild)
            {
                await new Promise(resolve => {
                    setTimeout(() => {
                        resolve();
                    }, 50);
                })
            }
            
            //
            let height = 0;

            //
            for(let item of this.$refs.wrapper.firstChild.children)
            {
                if(!item.getClientRects()[0])
                {
                    continue;
                }

                //
                height += item.getClientRects()[0].height;
            }
            
            //
            this.$emit("update:contentHeight", height);
        },

        scrollVerticalListener()
        {
            if(this.$refs.wrapper.scrollHeight - (this.$refs.wrapper.scrollTop + this.$refs.wrapper.getClientRects()[0].height) < 1)
            {
                //
                this.$emit("pullingUp");
            }

            //
            if(this.$refs.wrapper.scrollTop > this.originScrollTop)
            {
                this.$emit("scrollTop", this.$refs.wrapper.scrollTop, 'up')
            }
            else
            {
                this.$emit("scrollTop", this.$refs.wrapper.scrollTop, 'down')
            }
            
            //
            this.originScrollTop = this.$refs.wrapper.scrollTop;
        },

        scrollHorizonListener()
        {
            if(this.$refs.wrapper.scrollWidth - (this.$refs.wrapper.scrollLeft + this.$refs.wrapper.getClientRects()[0].width) < 1)
            {
                //
                this.$emit("pullingUp");
            }

            this.$emit("scrollLeft", this.$refs.wrapper.scrollLeft)
        },

        scrollListener()
        {
            //
            if(this.ifScrollHorizon)
            {
                this.scrollHorizonListener();
            }
            else
            {
                //
                this.scrollVerticalListener();
            }
        }
    }
}

</script>

<style lang="scss" scoped>

.wrapperVertical {
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
}

.wrapperHorizon {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
}

</style>